import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { LogControllerDtoAccountLoginLogListRequest, PerplayLogApi } from '../../models/src';
import {
  loginLogList,
  setLoginLogPagination,
  setTotalCount,
} from '../../actions/log/loginLogActions';
import { LOGINLOG_LIST_REQUEST } from '../../constants/log/loginLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoAccountLoginLogListResponse
  from '../../models/src/model/LogControllerDtoAccountLoginLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* loginLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoAccountLoginLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.searchString = payload.searchString;
    console.log(requestData);

    const result = yield api.apiPerplayLogAccountLoginLogListPost({ logControllerDtoAccountLoginLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoAccountLoginLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(loginLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(
      setLoginLogPagination(
        payload.page,
        data.totalCount,
        payload.beginDate,
        payload.endDate,
        payload.searchString,
      ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* loginLogRootSaga() {
  yield all([takeEvery(LOGINLOG_LIST_REQUEST, loginLogListRequestSaga)]);
}

const loginLogSagas = [fork(loginLogRootSaga)];

export default loginLogSagas;
